/*
  PDP image lightbox.

  The gallery had no way to see an image large — clicking the main image did
  nothing, which reads as broken on a page where the photo is most of the
  decision. Each slide is wrapped in a button carrying a full-size URL; this
  opens it over the page.

  Deliberately separate from spartan-pdp-gallery.js, which returns early for
  products with a single image. A single photo still needs to be enlargeable.

  Built once, lazily, and reused. The overlay lives on document.body rather
  than inside .sp-scope so nothing in the page can clip it.
*/
(function () {
  var overlay = null;
  var imgEl = null;
  var prevBtn = null;
  var nextBtn = null;
  var items = [];
  var index = 0;
  var lastFocus = null;

  function build() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.className = 'sp-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image');
    overlay.innerHTML =
      '<button class="sp-lightbox-close" type="button" aria-label="Close image">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button class="sp-lightbox-nav sp-lightbox-nav--prev" type="button" aria-label="Previous image">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<img class="sp-lightbox-img" alt="">' +
      '<button class="sp-lightbox-nav sp-lightbox-nav--next" type="button" aria-label="Next image">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';

    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('img');
    prevBtn = overlay.querySelector('.sp-lightbox-nav--prev');
    nextBtn = overlay.querySelector('.sp-lightbox-nav--next');

    overlay.querySelector('.sp-lightbox-close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });

    // Clicking the backdrop closes; clicking the photo itself does not.
    // The image is a direct flex child, so anything that is not the image or a
    // control is the backdrop.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { show(index - 1); }
      else if (e.key === 'ArrowRight') { show(index + 1); }
    });
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    var item = items[index];
    imgEl.src = item.src;
    imgEl.alt = item.alt || '';
    var many = items.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
  }

  function open(i) {
    build();
    lastFocus = document.activeElement;
    show(i);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    overlay.querySelector('.sp-lightbox-close').focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    imgEl.removeAttribute('src');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-sp-zoom]'));
    if (!buttons.length) return;

    items = buttons.map(function (b) {
      var img = b.querySelector('img');
      return { src: b.getAttribute('data-sp-zoom'), alt: img ? img.alt : '' };
    });

    buttons.forEach(function (b, i) {
      // The gallery track is a scroll-snap row, so a swipe ends in a click on
      // the image. Only treat it as a click if the pointer barely moved.
      var startX = 0, startY = 0, moved = false;
      b.addEventListener('pointerdown', function (e) {
        startX = e.clientX; startY = e.clientY; moved = false;
      });
      b.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) moved = true;
      });
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (moved) { moved = false; return; }
        open(i);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
